import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { TOP_LEVEL_TOKENS, isLetterTokenActive } from '@/helpers/catalogLetters';

interface IAlphabetProps {
}

export default function Alphabet({
}: IAlphabetProps) {
  const router = useRouter();
  const current = router.query.letter as string || '';

  return (
    <Container>
      <div className="maxwidth">
          <span>Алфавитный указатель:</span>
          {TOP_LEVEL_TOKENS.map((letter, key) =>
            <Link
              href={`/catalog/${encodeURIComponent(letter)}/1`}
              key={key}
              className={isLetterTokenActive(current, letter) ? 'current' : ''}>

              {letter.toUpperCase()}
            </Link>
          )}
      </div>
    </Container>
  );
}

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    border-top: 1px solid #eee;
    height: 45px;

    & > div {
        justify-content: space-between;
        display: flex;
        align-items: center;

        overflow-x: scroll;

        /* @media (max-width: 480px) {
          overflow-x: scroll;
        } */
    }

    & > div::-webkit-scrollbar {
        width: 0;
        height: 0;
    }

    & > div > span {
        margin-right: 20px;
    }

    & a {
        color: var(--red);
        padding: 10px;
        border-radius: 4px;

        white-space: nowrap;
    }

    & a:hover, a.current {
        background-color: var(--red);
        color: #fff !important;
    }

`
